import { FormEvent } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '../../../../../components/ui/use-toast'
import { teamsService } from '../../../../../../app/services/teamsService'

export const useRemoveTeamController = () => {
  const queryClient = useQueryClient()
  const { toast } = useToast()

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['deleteTeam'],
    mutationFn: async ({ teamId }: { teamId: string }) =>
      await teamsService.removeTeam(teamId),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['Allteams', {}],
      })
    },
  })

  const handleRemoveTeam = async (
    event: FormEvent<HTMLFormElement>,
    teamId: string,
  ) => {
    event.preventDefault()
    try {
      const response = await mutateAsync({ teamId })

      if (response.success) {
        toast({
          title: 'Equipe removida com sucesso',
        })
      }
    } catch (error) {
      console.log(error)
      toast({
        variant: 'destructive',
        title: 'Erro ao remover a equipe, tente novamente mais tarde.',
      })
    }
  }

  return {
    handleRemoveTeam,
    isPending,
  }
}
